import React, { Component } from 'react';
import {Link} from "react-router";
import SiteService from "../service/SiteService";

class Footer extends Component {
  render() {
    return (
        <div className="block block-inverse app-footer footer">
            <div className="container">
                <div className="row">
                    <div className="col-sm-5 m-b-md">
                        <ul className="list-unstyled list-spaced">
                            <li className="m-b"><h6 className="text-uppercase">About Gatehill Software</h6></li>
                            <li className="text-muted">
                                At Gatehill Software, we've been building software for over two decades to help people make the most of their time.
                                If you’d like to learn more about us,
                                find us at <a href="https://www.gatehill.io">gatehill.io</a>.
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-offset-1 col-sm-2 m-b-md">
                        {SiteService.isBotSite() &&
                        <ul className="list-unstyled list-spaced">
                            <li className="m-b"><h6 className="text-uppercase">Product</h6></li>
                            <li className="text-muted"><Link to="/docs/bot/actions">Examples</Link></li>
                            <li className="text-muted"><Link to="/docs/bot/faq">FAQs</Link></li>
                            <li className="text-muted"><Link to="/docs">Help</Link></li>
                        </ul>}
                        {SiteService.isMocksSite() &&
                        <ul className="list-unstyled list-spaced">
                            <li className="m-b"><h6 className="text-uppercase">Product</h6></li>
                            <li className="text-muted"><Link to="/docs/mocks/samples">Examples</Link></li>
                            <li className="text-muted"><Link to="/docs/mocks/faq">FAQs</Link></li>
                            <li className="text-muted"><Link to="/docs">Help</Link></li>
                        </ul>}
                    </div>
                    <div className="col-sm-2 m-b-md">
                        <ul className="list-unstyled list-spaced">
                            <li className="m-b"><h6 className="text-uppercase">Legal</h6></li>
                            <li className="text-muted"><Link to="/legal/terms">Terms and Conditions</Link></li>
                            <li className="text-muted"><Link to="/legal/privacy">Privacy</Link></li>
                            <li className="text-muted"><Link to="/legal/license">License</Link></li>
                        </ul>
                    </div>
                    <div className="col-sm-2 m-b-md">
                        <ul className="list-unstyled list-spaced">
                            <li className="m-b"><h6 className="text-uppercase">About us</h6></li>
                            <li className="text-muted"><Link to="/docs/about">About</Link></li>
                            <li className="text-muted"><Link to="/docs/about/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/modules/common/Footer.js